import React, { useState } from "react";
import { Play } from "lucide-react";

export default function YouTubeEmbed({ id, title }) {
  const [play, setPlay] = useState(false);
  return (
    <div className="relative aspect-video w-full overflow-hidden bg-black shadow-xl">
      {play ? (
        <iframe
          className="h-full w-full"
          src={`https://www.youtube.com/embed/${id}?autoplay=1&rel=0`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <button
          onClick={() => setPlay(true)}
          className="group absolute inset-0 h-full w-full"
          aria-label={`Play video: ${title}`}
        >
          <img
            src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`}
            alt={title}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute inset-0 bg-black/30 transition-colors duration-300 group-hover:bg-black/45" />
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="flex h-[68px] w-[100px] items-center justify-center rounded-lg bg-[#a10000] transition-transform duration-300 group-hover:scale-110">
              <Play className="h-8 w-8 fill-white text-white" />
            </span>
          </span>
          <span className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4 text-left text-sm font-semibold text-white">
            {title}
          </span>
        </button>
      )}
    </div>
  );
}
